import { appAuthAtom, LogoutReason } from '@eih-netbroker/common';
import { useAtomValue } from 'jotai';
import { useCallback, useEffect, useState } from 'react';
import { useDialog } from '../../../context/DialogContext';
import { MobileAppBanner } from '../../../shared/components/mobile-app-banner/MobileAppBanner';
import { Config } from '../../../shared/config/config';
import { DeviceDetectionUtils } from '../../../shared/utils/deviceDetection';
import { CookieConsent } from '../partials/CookieConsent';
import { LoginView } from '../partials/LoginVew';
import { UnsuccessfulLoginModal } from '../partials/UnsuccessfulLoginModal';

export const LoginPage = () => {
  const { openDialog } = useDialog();
  const appAuthState = useAtomValue(appAuthAtom);
  const [showMobileAppBanner, setShowMobileAppBanner] = useState(false);

  useEffect(() => {
    if (DeviceDetectionUtils.isMobileDevice() && Config.FeatureFlags.isMobileAppBannerEnabled) {
      setShowMobileAppBanner(true);
    }
  }, []);

  const openLoginErrorModal = useCallback(
    async (error: Exclude<LogoutReason, 'SSOCallbackError' | 'OtherInstanceLoggedOut'>) => {
      await openDialog((close: () => void) => (
        <UnsuccessfulLoginModal
          onClose={close}
          reason={error}
        />
      ));
    },
    [openDialog],
  );

  useEffect(() => {
    if (
      !appAuthState.isAuthenticated &&
      appAuthState.error &&
      appAuthState.error !== 'SSOCallbackError' &&
      appAuthState.error !== 'OtherInstanceLoggedOut'
    ) {
      openLoginErrorModal(appAuthState.error);
    }
  }, [appAuthState, openLoginErrorModal]);

  return (
    <>
      <LoginView />
      <CookieConsent />
      {showMobileAppBanner && Config.FeatureFlags.isMobileAppBannerEnabled && (
        <MobileAppBanner onDismiss={() => setShowMobileAppBanner(false)} />
      )}
    </>
  );
};

export default LoginPage;
